import Counter from '../Counter';
import Icon from '../Icon';

const Demo6Content3 = () => {
    return (
        <section id="content-3" className="bg-snow content-3 wide-60 content-section division">
            <div className="container">
                {/* TOP ROW */}
                <div className="top-row pb-50">
                    <div className="row d-flex align-items-center">
                        {/* Image column */}
                        <div className="col-md-5 col-lg-6 order-last order-lg-1">
                            <div className="img-block left-column wow fadeInRight">
                                <img
                                    className="img-fluid"
                                    src="/images/demo6/Workflow.png"
                                    alt="Analytics dashboard"
                                />
                            </div>
                        </div>

                        {/* Text column */}
                        <div className="col-md-7 col-lg-6 order-first order-lg-2">
                            <div className="txt-block right-column wow fadeInLeft">
                                <span className="section-id txt-upcase">Totally Optimised</span>
                                <h2 className="h2-xs">Your Entire Translation Workflow, Streamlined</h2>

                                <p className="p-lg">
                                    Get started in minutes — just upload your document, select your source and target
                                    languages, and let Rush Studio handle the rest.
                                </p>
                                <p className="p-lg">
                                    All files are securely stored in the cloud, and soon you’ll be able to connect
                                    directly to your favorite tools with third-party integrations.
                                </p>

                                <ol
                                    style={{
                                        display: 'inline-block',
                                        textAlign: 'left',
                                        fontSize: '1.1rem',
                                        color: '#374151',
                                        lineHeight: 1.8,
                                        margin: 0,
                                        paddingLeft: '1.25rem',
                                    }}
                                >
                                    <li>
                                        <strong>Upload your document:</strong> Drop in DOCX, PDF, or other supported
                                        files — ready for translation in seconds.
                                    </li>
                                    <li>
                                        <strong>Choose your source language:</strong> Select the document’s original
                                        language for accurate detection and setup.
                                    </li>
                                    <li>
                                        <strong>Select target languages:</strong> Pick one or more target languages —
                                        our smart tools and workflows handle the rest.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* BOTTOM ROW */}
                <div className="bottom-row">
                    <div className="row d-flex align-items-center">
                        {/* Text column */}
                        <div className="col-lg-6 order-last order-lg-2">
                            <div className="txt-block slim-column left-column wow fadeInRight">
                                <div className="txt-box mb-20">
                                    <h5 className="h5-lg">Enterprise-Grade Security</h5>
                                    <p className="p-lg">
                                        Your data is protected with state-of-the-art encryption, secure role-based access
                                        controls, and compliance with global data privacy standards. We ensure your
                                        intellectual property remains safe at every step.
                                    </p>
                                </div>

                                <div className="txt-box">
                                    <h5 className="h5-lg">Built for Speed & Scale</h5>
                                    <ul className="simple-list">
                                        <li className="list-item">
                                            <p className="p-lg">
                                                Handle complex projects with thousands of files without compromising
                                                performance.
                                            </p>
                                        </li>
                                        <li className="list-item">
                                            <p className="p-lg">
                                                Automated workflows reduce manual errors and speed up delivery times by
                                                up to 50%.
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Card/metrics column */}
                        <div className="col-lg-6 order-first order-lg-1">
                            <div className="cb-wrapper">
                                <div className="cb-holder wow fadeInLeft">
                                    <div className="cb-single-box">
                                        <p className="p-lg cb-header">Active Projects</p>
                                        <h2 className="h2-title-xs statistic-number">
                                            <sup>+</sup>
                                            <Counter end={784} />
                                        </h2>
                                        <p className="p-md mt-5 ico-10">
                                            <span className="green-color">
                                                <Icon symbol="▲" decorative className="icon-trend" /> 4.6%
                                            </span>{' '}
                                            vs last 7 days
                                        </p>
                                    </div>

                                    <hr className="divider" />

                                    <div className="cb-single-box">
                                        <ul className="simple-list">

                                            <li className="list-item">
                                                <p className="p-md">
                                                    Seamless integration with Figma and Slack
                                                </p>
                                            </li>
                                            <li className="list-item">
                                                <p className="p-md">Real-time collaboration for global teams</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="cb-single-box cb-box-rounded bg-green white-color mt-25">
                                        <h4 className="h4-lg">1.2M+</h4>
                                        <p className="p-lg">Words Translated</p>
                                    </div>
                                </div>

                                {/* Decorative shapes (use /public paths or import from src) */}
                                <div className="cb-shape-1">
                                    <img
                                        className="img-fluid"
                                        src="/images/demo6/bg-shape-1.png"
                                        alt="decorative shape"
                                    />
                                </div>
                                <div className="cb-shape-2">
                                    <img
                                        className="img-fluid"
                                        src="/images/demo6/bg-shape-2.png"
                                        alt="decorative shape"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content3;
